import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PasswordComponent } from './password/password.component';
import { ModifyComponent } from './modify/modify.component';
import { LoginComponent } from './login/login.component';


@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule],
    declarations: [ModifyComponent, PasswordComponent, LoginComponent],
})
export class UserModule {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/user/user.module.ts